import React, { Component } from 'react';
import { Popconfirm } from 'antd';
import ComTable from '../ComTable';

class ClinicalTrialExp extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const { canEdit } = this.props;
        const config = [{
            zh: '项目领域',
            en: 'Therapeutic Area',
            key: 'investigationAreaName',
            width: 140,
        }, {
            zh: '疾病',
            en: 'Indications',
            key: 'diseaseName',
            width: 140,
        }, {
            zh: '项目角色',
            en: 'Role',
            key: 'clinicalRoleName',
            width: 70,
        }, {
            zh: '项目类型',
            en: 'Study Type',
            key: 'clinicalTypeName',
            width: 140,
        }, {
            zh: '参与时间',
            en: 'Time',
            key: 'joinTime',
            width: 120,
        }, {
            zh: '研究产品类型',
            en: 'Investigational Product Type',
            key: 'investigationProductName',
        }, {
            zh: '项目分期',
            en: 'Study Phase',
            key: 'investigationProductStageName',
            width: 120,
        }];
        if (canEdit) {
            config.push({
                zh: '操作',
                en: 'Operation',
                key: 'operate',
                width: 80,
                render: (text, row) => {
                    const { vitaeClinicalExperienceId } = row;
                    return (
                        <Popconfirm title="确定要删除吗?" onConfirm={() => this.props.delete(vitaeClinicalExperienceId)}>
                            <a>删除</a>
                        </Popconfirm>
                    );
                }
            });
        }
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                investigationAreaName,
                investigationAreaEnglishName,
                diseaseName,
                diseaseEnglishName,
                diseaseRemarkChinese,
                diseaseRemarkEnglish,
                clinicalRoleName,
                clinicalRoleEnglishName,
                clinicalTypeName,
                clinicalTypeEnglishName,
                clinicalStartTime,
                clinicalEndTime,
                investigationProductName,
                investigationProductEnglishName,
                investigationProductStageName,
                investigationProductStageEnglishName,
                investigationProductStageRemarkChinese,
                investigationProductStageRemarkEnglish,
                clinicalRoleCommentsChinese,
                clinicalRoleCommentsEnglish,
            } = item;
            const diseaseRemark = isChinese ? diseaseRemarkChinese : diseaseRemarkEnglish;
            const clinicalRoleComments = isChinese ? clinicalRoleCommentsChinese : clinicalRoleCommentsEnglish;
            const investigationProductStageRemark = isChinese ? investigationProductStageRemarkChinese : investigationProductStageRemarkEnglish;
            return {
                index: index + 1,
                ...item,
                investigationAreaName: isChinese ? investigationAreaName : investigationAreaEnglishName,
                diseaseName: `${isChinese ? diseaseName : diseaseEnglishName}${diseaseRemark ? `(${diseaseRemark})` : ''}`,
                clinicalRoleName: `${isChinese ? clinicalRoleName : clinicalRoleEnglishName}${clinicalRoleComments ? `(${clinicalRoleComments})` : ''}`,
                clinicalTypeName: isChinese ? clinicalTypeName : clinicalTypeEnglishName,
                joinTime: `${clinicalStartTime.slice(0, 7)}~${clinicalEndTime ? clinicalEndTime.slice(0, 7) : isChinese ? '至今' : 'Present'}`,
                investigationProductName: isChinese ? investigationProductName : investigationProductEnglishName,
                investigationProductStageName: `${isChinese ? investigationProductStageName : investigationProductStageEnglishName}${investigationProductStageRemark ? `(${investigationProductStageRemark})` : ''}`,
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default ClinicalTrialExp;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/ClinicalTrialExp.js